window.PlummeI18n.register('en', {
  'pref.salesMode': 'Default view for new sales',
  'pref.salesModeSub': 'Used for invoices, quotes, order confirmations, credit notes and other sales. You can switch view temporarily in the form.',
  'pref.purchaseMode': 'Default view for new purchases',
  'pref.purchaseModeSub': 'Choose whether new purchases normally open step by step or with the whole form on one page.',
  'pref.mode.firstChoiceHelp': 'This becomes your default. You can switch view in the form or change the default later under Settings → Preferences.',
  'pref.mode.saveFailed': 'The view changed, but the default could not be saved. Try again under Settings → Preferences.',
  'pref.mode.unsupported': 'Invalid view selection.',
});
